import React from 'react';
import { Redirect, useLocation } from 'react-router-dom';

import { useAuthContext } from 'contexts/AuthContext';
import { getPostLoginRedirect } from 'utils/postLoginRedirect';

function AuthGuard(props: any) {
  const { children } = props;

  const { auth } = useAuthContext();
  const location = useLocation();

  if (auth?.token) {
    return <Redirect to={getPostLoginRedirect(location.search) || '/'} />;
  }

  return children;
}

export default AuthGuard;
